import type { State } from './reducer'
import { fetchPageData } from 'shared/store/actions'
import type { ActionsNetwork } from 'shared/store/actions'
import endpoints from 'shared/store/endpoints'
import type { Dispatch } from 'redux'

type ActionNotFoundPageDataResponse = {
    type: 'PAGE_DATA_NOTFOUND_RESPONSE',
    data: State
}

type ActionNotFoundPageDataReset = {
    type: 'PAGE_DATA_NOTFOUND_RESET'
}

const fetchNotFoundPageData = () =>
    fetchPageData(endpoints.pages.notFound, 'PAGE_DATA_NOTFOUND_RESPONSE')

const resetNotFoundPageData = () => {
    return (dispatch: Dispatch<any>) => {
        dispatch({
            type: 'PAGE_DATA_NOTFOUND_RESET'
        })
    }
}

export { fetchNotFoundPageData, resetNotFoundPageData }

export type Action =
    | ActionNotFoundPageDataResponse
    | ActionNotFoundPageDataReset
    | ActionsNetwork
